import { LoaderCircleIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PageLoaderProps {
  /** Optional message shown below the spinner */
  message?: string;
  /** When true, uses min-h-screen for full-page loading (e.g. conversations) */
  fullPage?: boolean;
  className?: string;
  /** Size of the spinner: sm (24px), default (32px), lg (40px) */
  size?: 'sm' | 'default' | 'lg';
}

const sizeClasses = {
  sm: 'size-6',
  default: 'size-8',
  lg: 'size-10',
};

export const PageLoader = ({
  message,
  fullPage = false,
  className,
  size = 'default',
}: PageLoaderProps) => (
  <div
    className={cn(
      'flex items-center justify-center',
      fullPage ? 'min-h-screen' : 'py-12',
      className
    )}
  >
    <div className="text-center">
      <LoaderCircleIcon
        className={cn('animate-spin text-primary mx-auto', sizeClasses[size])}
        aria-hidden
      />
      {message && (
        <p className="mt-4 text-sm text-muted-foreground" role="status">
          {message}
        </p>
      )}
    </div>
  </div>
);
